import { combineReducers } from 'redux'
import freequoteReducer from './freequoteReducer'
import AuthReducer from './AuthReducer'
import sideNavReducer from './MyHavenSideMenuReducer'
import FirebaseReducer from './FirebaseReducer'
import loadingReducer from './LoadingReducer'
import showReferralsReducer from './showReferralsReducer';

//chart reducers
import monthlyReducer from './MonthChartReducer';
import annuallyReducer from './AnnualChartReducer';
import dailyReducer from './DailyChartReducer'
import weeklyReducer from './WeekChartReducer'
import previousAnnuallyReducer from './PreviousAnnualChartReducer'
import selectedMonthReducer from './GetSelectedMonthReducer'
import selectedDayReducer from './GetSelectedDayReducer'
import selectedDayFromWeekReducer from './GetSelectedDayFromWeekReducer'

export default combineReducers({
    showfreequote: freequoteReducer,
    is_authenticated: AuthReducer,
    showMenu: sideNavReducer,
    firebase: FirebaseReducer,
    loading: loadingReducer,
    showReferrals: showReferralsReducer,
    monthlyChart: monthlyReducer,
    annuallyChart: annuallyReducer,
    dailyChart: dailyReducer,
    weeklyChart: weeklyReducer,
    previousAnnuallyChart: previousAnnuallyReducer,
    selectedMonthChart: selectedMonthReducer,
    selectedDayChart: selectedDayReducer,
    selectedDayFromWeekChart: selectedDayFromWeekReducer
});


// WEBPACK FOOTER //
// ./src/Reducers/Root.js